import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type/list`);
  return response;
};

const getAllComplete = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type/get/all`);
  return response;
};

const getAllActive = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type/get/active`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type/${id}`);
  return response;
};

const getByOdooId = async (odooId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type/odoo/${odooId}`);
  return response;
};

// ===== FUNCIONES MANUALES (Desde Nómina) =====

const insertManual = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_leave_type/manual/create`, payload);
  return response;
};

const updateManual = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo_leave_type/manual/update`, payload);
  return response;
};

const dropManual = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}odoo_leave_type/manual/delete/${id}`);
  return response;
};

export {getAll, getList, getAllComplete, getAllActive, getById, getByOdooId, insertManual, updateManual, dropManual};